import { useState, useEffect, useCallback } from "react";

/**
 * Tiny hook that mirrors useState but reads/writes the value to localStorage.
 * Safe in SSR (returns initial value) and silently degrades on private-mode failures.
 */
export function usePersistentState(key, initial) {
  const [value, setValue] = useState(() => {
    if (typeof window === "undefined") return initial;
    try {
      const raw = localStorage.getItem(key);
      if (raw == null) return initial;
      return JSON.parse(raw);
    } catch (e) {
      console.warn(`usePersistentState(${key}): read failed`, e);
      return initial;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      console.warn(`usePersistentState(${key}): write failed`, e);
    }
  }, [key, value]);

  const reset = useCallback(() => setValue(initial), [initial]);
  return [value, setValue, reset];
}
